<template>
	<el-container class="group-page">
		<resizable-aside :default-width="260" :min-width="200" :max-width="500" storage-key="group-aside-width">
			<div class="header">
				<el-input class="search-text" size="small" placeholder="搜索" v-model="searchText">
					<i class="el-icon-search el-input__icon" slot="prefix"> </i>
				</el-input>
			</div>
			<el-scrollbar class="group-items">
				<div v-for="(groups, i) in groupValues" :key="i">
					<div class="letter">{{ groupKeys[i] }}</div>
					<div v-for="group in groups" :key="group.groupID">
						<group-item :group="group" :active="group.groupID === activeGroup.groupID"
							@click.native="onActiveItem(group)">
						</group-item>
					</div>
					<div v-if="i < groupValues.length - 1" class="divider"></div>
				</div>
			</el-scrollbar>
		</resizable-aside>
		<el-container class="container">
			<div class="header" v-show="activeGroup.groupID">{{ activeGroup.nickname || '未命名群聊' }}</div>
			<div v-show="activeGroup.groupID">
				<div class="group-info">
					<head-image :size="160" :name="activeGroup.nickname" :url="activeGroup.avatar" radius="10%"></head-image>
					<div>
						<div class="info-item">
							<el-descriptions title="群信息" class="description" :column="1">
								<el-descriptions-item label="群名称">{{ activeGroup.nickname || '未命名群聊' }}</el-descriptions-item>
								<el-descriptions-item label="群成员数">{{ activeGroup.total }}</el-descriptions-item>
								<el-descriptions-item label="群ID">{{ activeGroup.groupID }}</el-descriptions-item>
								<el-descriptions-item label="企微VID">{{ activeGroup.vid }}</el-descriptions-item>
								<el-descriptions-item label="所属账号">{{ activeGroup.accountID }}</el-descriptions-item>
								<el-descriptions-item label="创建时间">{{ formatTime(activeGroup.createTime) }}</el-descriptions-item>
								<el-descriptions-item label="更新时间">{{ formatTime(activeGroup.updateTime) }}</el-descriptions-item>
							</el-descriptions>
						</div>
						<div class="btn-group">
							<el-button icon="el-icon-position" type="primary" @click="onSendMessage()">发消息</el-button>
						</div>
					</div>
				</div>
			</div>
		</el-container>
	</el-container>
</template>

<script>
import GroupItem from '../components/group/GroupItem';
import HeadImage from '../components/common/HeadImage.vue';
import ResizableAside from "../components/common/ResizableAside.vue";
import { pinyin } from 'pinyin-pro';
import { buildGroupConvID } from "../utils/conversation.js";

export default {
	name: "group",
	components: {
		GroupItem,
		HeadImage,
		ResizableAside
	},
	data() {
		return {
			searchText: "",
			activeGroup: {}
		};
	},
	methods: {
		onActiveItem(group) {
			this.activeGroup = group;
		},
		onSendMessage() {
			// 优先查找已有会话，避免因conversationID格式差异导致重复创建
			let existingChat = this.chatStore.findChatByGroup(this.activeGroup.groupID);
			let tenantID = this.userStore.userInfo.tenantID || 1;
			let conversationID = existingChat
				? existingChat.conversationID
				: buildGroupConvID(tenantID, this.activeGroup.groupID);
			let chat = {
				conversationID: conversationID,
				convType: 'group',
				groupID: this.activeGroup.groupID,
				showName: this.activeGroup.nickname || '未命名群聊',
				faceURL: this.activeGroup.avatar || '',
				groupMemberCount: this.activeGroup.total || 0,
				source: this.activeGroup.vid, // 发送账号VID（群列表已按当前客服过滤，即本客服的群内账号）
				customer: this.activeGroup.customer
			};
			this.chatStore.openChat(chat);
			this.chatStore.setActiveChat(0);
			this.$router.push("/home/chat");
		},
		formatTime(timestamp) {
			if (!timestamp) return '-';
			return new Date(timestamp * 1000).toLocaleString('zh-CN');
		},
		reset() {
			this.activeGroup = {};
		},
		firstLetter(strText) {
			// 群名可能为空（存量群未同步到群名）：空输入返回空串，由调用方归入 "#" 分组，
			// 避免 pinyin('') 返回空串后取 [0] 得 undefined 导致 toUpperCase 崩溃
			if (!strText) {
				return '';
			}
			let pinyinOptions = {
				toneType: 'none',
				type: 'normal'
			};
			let pyText = pinyin(strText, pinyinOptions);
			return pyText[0] || '';
		},
		isEnglish(character) {
			return /^[A-Za-z]+$/.test(character);
		}
	},
	mounted() {
		// 进入群列表页刷新一次：群头像由服务端异步回填，刷新可拿到最新头像/人数
		this.groupStore.loadGroup().catch(() => {});
	},
	computed: {
		groupMap() {
			let map = new Map();
			const allGroups = this.groupStore.groups;
			console.log('[Group.vue] groupMap 计算, groupStore.groups 总数:', allGroups.length);
			allGroups.forEach((g) => {
				if (g.quit || (this.searchText && !(g.nickname || '').includes(this.searchText))) {
					return;
				}
				let letter = this.firstLetter(g.nickname).toUpperCase();
				if (!this.isEnglish(letter)) {
					letter = "#"
				}
				if (map.has(letter)) {
					map.get(letter).push(g);
				} else {
					map.set(letter, [g]);
				}
			})
			let arrayObj = Array.from(map);
			arrayObj.sort((a, b) => {
				if (a[0] == '#' || b[0] == '#') {
					return b[0].localeCompare(a[0])
				}
				return a[0].localeCompare(b[0])
			})
			map = new Map(arrayObj.map(i => [i[0], i[1]]));
			return map;
		},
		groupKeys() {
			return Array.from(this.groupMap.keys());
		},
		groupValues() {
			return Array.from(this.groupMap.values());
		}
	}
}
</script>

<style lang="scss" scoped>
.group-page {

	.header {
		height: 50px;
		display: flex;
		align-items: center;
		padding: 0 8px;
	}

	.group-items {
		flex: 1;

		.letter {
			text-align: left;
			font-size: var(--im-larger-size-larger);
			padding: 5px 15px;
			color: var(--im-text-color-light);
		}
	}

	.container {
		display: flex;
		flex-direction: column;

		.header {
			display: flex;
			justify-content: space-between;
			padding: 0 12px;
			line-height: 50px;
			font-size: var(--im-font-size-larger);
			border-bottom: var(--im-border);
		}

		.group-info {
			display: flex;
			padding: 50px 80px 20px 80px;
			text-align: center;

			.info-item {
				margin-left: 20px;
				background-color: #ffffff;
				border: 1px #ddd solid;
			}

			.description {
				padding: 20px 20px 0 20px;
			}
		}

		.btn-group {
			text-align: left !important;
			padding: 20px;
		}
	}
}
</style>
